import { defineMessages } from "react-intl";

// The section's own name (title, sidebar entry, window title) is
// sectionNames.atticActivityLog in src/intl.ts.
export const activityLogMessages = defineMessages({
  subtitle: {
    id: "0+Jmtu",
    defaultMessage: "Who did what, and when. Entries are written by the server and never change.",
    description: "activity log, page subtitle",
  },
  searchPlaceholder: {
    id: "V/Kjgs",
    defaultMessage: "Search what happened",
    description: "activity log, search box placeholder",
  },
  kind: {
    id: "wqdf5k",
    defaultMessage: "Kind",
    description: "activity log, kind filter label",
  },
  kindAll: {
    id: "joGYPA",
    defaultMessage: "All",
    description: "activity log, kind filter: every kind",
  },
  kindCreated: {
    id: "mZ9bS5",
    defaultMessage: "Created",
    description: "activity log, kind filter option",
  },
  kindEdited: {
    id: "YffHcc",
    defaultMessage: "Edited",
    description: "activity log, kind filter option",
  },
  kindDeleted: {
    id: "Es1ptW",
    defaultMessage: "Deleted",
    description: "activity log, kind filter option",
  },
  kindStatusChanged: {
    id: "UcfYh1",
    defaultMessage: "Status changed",
    description: "activity log, kind filter option",
  },
  from: {
    id: "5y3o8C",
    defaultMessage: "From",
    description: "activity log, date range start label",
  },
  to: {
    id: "kAj8xW",
    defaultMessage: "To",
    description: "activity log, date range end label",
  },
  oneRecord: {
    id: "r5uG7u",
    defaultMessage: "Showing one record's history",
    description: "activity log, chip shown while the list is narrowed to one subject",
  },
  showAll: {
    id: "W8Awlg",
    defaultMessage: "Show all",
    description: "activity log, clears the one-record chip",
  },
  when: {
    id: "dKgauu",
    defaultMessage: "When",
    description: "activity log, table column",
  },
  who: {
    id: "9pfCus",
    defaultMessage: "Who",
    description: "activity log, table column",
  },
  what: {
    id: "xkTM7c",
    defaultMessage: "What",
    description: "activity log, table column",
  },
  subject: {
    id: "qFrLaM",
    defaultMessage: "Subject",
    description: "activity log, table column",
  },
  appTag: {
    id: "KOu7s0",
    defaultMessage: "app",
    description: "activity log, small tag beside an app's name in the Who column",
  },
  system: {
    id: "jMZGVo",
    defaultMessage: "System",
    description: "activity log, the Who column when nobody did it",
  },
  filterBySubject: {
    id: "a42llz",
    defaultMessage: "Show the history of {subject}",
    description: "activity log, subject cell button label",
  },
  empty: {
    id: "MdH8wv",
    defaultMessage: "Nothing has been logged yet.",
    description: "activity log, empty list",
  },
  noMatches: {
    id: "F/ykyv",
    defaultMessage: "No entries match these filters.",
    description: "activity log, empty list while a filter is set",
  },
  loadFailed: {
    id: "lTMH6h",
    defaultMessage: "The activity log could not be loaded. Try again.",
    description: "activity log, load failure",
  },
});
